import { auth, db, layAppTaoTaiKhoan } from "../firebase";
import { collection, doc, getDoc, getDocs, setDoc, updateDoc } from "firebase/firestore";
import {
  createUserWithEmailAndPassword,
  EmailAuthProvider,
  getAuth,
  reauthenticateWithCredential,
  sendPasswordResetEmail,
  signOut,
  updatePassword,
} from "firebase/auth";
import { langNgheFirestore } from "../lib/langNgheFirestore";

const nguoiDungCol = () => collection(db, "nguoiDung");

export const nguoiDungApi = {
  async danhSach() {
    const snap = await getDocs(nguoiDungCol());
    return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  },

  langNgheDanhSach(onChange, onError) {
    return langNgheFirestore(nguoiDungCol(), { onChange, onError });
  },

  async layMot(id) {
    const snap = await getDoc(doc(db, "nguoiDung", id));
    return snap.exists() ? { id: snap.id, ...snap.data() } : null;
  },

  langNgheChiTiet(id, onChange, onError) {
    if (!id) {
      onChange(null);
      return () => {};
    }
    return langNgheFirestore(doc(db, "nguoiDung", id), { onChange, onError });
  },

  async doiVaiTro(id, vaiTro) {
    await updateDoc(doc(db, "nguoiDung", id), { vaiTro });
  },

  // Sửa họ tên/SĐT — tự sửa hồ sơ của mình hoặc admin sửa cho người khác đều
  // gọi hàm này, firestore.rules đã phân biệt 2 trường hợp đó ở tầng quyền.
  async capNhatThongTin(id, { hoTen, sdt }) {
    await updateDoc(doc(db, "nguoiDung", id), { hoTen, sdt: sdt ?? "" });
  },

  // Đổi mật khẩu của chính người đang đăng nhập — Firebase Auth yêu cầu xác
  // thực lại bằng mật khẩu cũ trước khi cho đổi (thao tác nhạy cảm).
  async doiMatKhau(matKhauCu, matKhauMoi) {
    const nguoiDung = auth.currentUser;
    const cred = EmailAuthProvider.credential(nguoiDung.email, matKhauCu);
    await reauthenticateWithCredential(nguoiDung, cred);
    await updatePassword(nguoiDung, matKhauMoi);
  },

  // Tạo tài khoản đăng nhập (Auth) + hồ sơ vai trò (Firestore) cho nhân sự
  // mới, không cần Admin SDK. Dùng app Firebase phụ để phiên đăng nhập của
  // admin đang thao tác không bị thay bằng phiên của tài khoản vừa tạo.
  async taoTaiKhoan({ email, matKhauTam, hoTen, vaiTro }) {
    const authPhu = getAuth(layAppTaoTaiKhoan());
    const { user } = await createUserWithEmailAndPassword(authPhu, email, matKhauTam);
    const uid = user.uid;
    await signOut(authPhu);

    await setDoc(doc(db, "nguoiDung", uid), { hoTen, email, vaiTro });
    return { id: uid, hoTen, email, vaiTro };
  },

  guiEmailDatLaiMatKhau(email) {
    return sendPasswordResetEmail(auth, email);
  },

  // Không có Admin SDK (đã bỏ backend) nên không thể vô hiệu hoá tài khoản ở
  // tầng Firebase Auth. Thay vào đó chặn ở tầng dữ liệu: đặt cờ voHieuHoa,
  // firestore.rules (taiKhoanHoatDong) sẽ từ chối MỌI request Firestore của
  // người đó, AuthContext phát hiện lỗi quyền đó và tự đăng xuất họ.
  async datTrangThaiHoatDong(id, voHieuHoa) {
    await updateDoc(doc(db, "nguoiDung", id), { voHieuHoa });
  },
};
